import type { WelcomeGalaxyAppearance } from "@-/dev.improve.haniverse.routes.nav.app.auth/welcome-galaxy-palette";

/**
 * The onboarding's globe in each of the welcome galaxy's two looks, so the galaxy the learner
 * dives into and the Earth they arrive at belong to one picture: light on deep space in dark mode,
 * ink and pigment on paper in light mode.
 */
export type OnboardingGlobePalette = {
  /** The glow of the atmosphere around the disk. */
  atmosphere: string;
  /** China's borders between two cities of a province: the faintest lines, like the map's. */
  cityBorder: string;
  graticule: string;
  land: string;
  /** The disk's rim. */
  limb: string;
  /** The ocean's shading, lit from the upper left: its lit side, then its far side. */
  ocean: [string, string];
  /** China's borders between two provinces: fainter than its outline. */
  provinceBorder: string;
  stars: string;
  /** The status bar's text over the sky. */
  statusBarStyle: "dark" | "light";
};

const PALETTES: Record<WelcomeGalaxyAppearance, OnboardingGlobePalette> = {
  dark: {
    atmosphere: "rgba(120, 170, 255, 0.55)",
    cityBorder: "rgba(214, 228, 255, 0.16)",
    graticule: "rgba(170, 200, 255, 0.12)",
    land: "rgba(214, 228, 255, 0.62)",
    limb: "rgba(170, 205, 255, 0.55)",
    ocean: ["rgba(34, 60, 112, 1)", "rgba(6, 12, 30, 1)"],
    provinceBorder: "rgba(214, 228, 255, 0.42)",
    stars: "rgba(255, 255, 255, 0.9)",
    statusBarStyle: "light",
  },
  light: {
    atmosphere: "rgba(90, 120, 190, 0.28)",
    cityBorder: "rgba(40, 46, 72, 0.16)",
    graticule: "rgba(40, 52, 90, 0.1)",
    land: "rgba(40, 46, 72, 0.6)",
    limb: "rgba(40, 52, 90, 0.45)",
    ocean: ["rgba(246, 244, 238, 1)", "rgba(218, 224, 234, 1)"],
    provinceBorder: "rgba(40, 46, 72, 0.4)",
    // Graphite tone marks, like the light welcome galaxy's background.
    stars: "rgba(90, 90, 90, 1)",
    statusBarStyle: "dark",
  },
};

export function onboardingGlobePalette(
  appearance: WelcomeGalaxyAppearance,
): OnboardingGlobePalette {
  return PALETTES[appearance];
}
